<template>
  <header class="l-header">
    <div class="l-header__primary">
      <p class="l-header__siteName">
        <KkIcon :name="logoName" />
      </p>
    </div>
  </header>
</template>

<script>
import { KkIcon } from '../components/base'
import { KCOM_URLS, LOCALONE_URLS, RETTY_URLS } from '../modules/urls'

export default {
  // ログイン前画面の共通ヘッダー
  name: 'PublicHeader',
  components: { KkIcon },
  computed: {
    logoName() {
      if(KCOM_URLS.some(url => document.domain.includes(url))) return 'logoBlack'
      if(LOCALONE_URLS.some(url => document.domain.includes(url))) return 'logoLocalOne'
      if(RETTY_URLS.some(url => document.domain.includes(url))) return 'logoRetty'
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../stylesheets/biz_spa/foundation/_var.scss';
@import '../../../stylesheets/biz_spa/foundation/_mixin.scss';
@include mq(lg) {
  .l-header__primary {
    display: block;
    padding: 20px 40px;
  }
  .l-header__siteName {
    display: flex;
    align-items: center;
    max-width: 100px;
  }
}
</style>
